import {
    SlidersHorizontal, TreeStructure, MapPin, MapTrifold, MagnifyingGlass,
    Funnel, FunnelX, X, CaretDown, Check, ClipboardText, ArrowUpRight,
    DotsThree, Eye, PencilSimple, ArrowsClockwise, Trash, Paperclip,
    FileCsv, FilePdf, FileText, ListBullets, Flag, Tray, User, House,
    Phone, Envelope, IdentificationCard, Buildings, Info, Star,
    GitBranch, ChatText, UserCheck, Clock, Prohibit, ArrowsDownUp,
    ArrowUp, ArrowDown, CaretDoubleLeft, CaretDoubleRight, ChartBar,
    LockOpen, WarningOctagon, SealCheck, CheckCircle, TreeEvergreen, CirclesThree,
} from '@phosphor-icons/react';
import { Icon as FallbackIcon } from '@iconify/react';

// Locally bundled outline icons keep both complaint popups visually consistent.
const icons = {
    'forest-zone': TreeEvergreen,
    'forest-circle': CirclesThree,
    'mdi:tune-variant': SlidersHorizontal,
    'mdi:map-marker-radius': MapTrifold,
    'mdi:map-marker-path': TreeStructure,
    'mdi:map-marker': MapPin,
    'mdi:map-marker-outline': MapPin,
    'mdi:map': MapTrifold,
    'mdi:map-outline': MapTrifold,
    'mdi:magnify': MagnifyingGlass,
    'mdi:filter': Funnel,
    'mdi:filter-variant': Funnel,
    'mdi:filter-off': FunnelX,
    'mdi:filter-remove-outline': FunnelX,
    'mdi:close': X,
    'mdi:chevron-down': CaretDown,
    'mdi:check': Check,
    'mdi:clipboard-text-outline': ClipboardText,
    'mdi:arrow-top-right': ArrowUpRight,
    'mdi:dots-horizontal': DotsThree,
    'majesticons:eye-line': Eye,
    'lucide:edit': PencilSimple,
    'lucide:refresh-cw': ArrowsClockwise,
    'fluent:delete-24-regular': Trash,
    'mdi:paperclip': Paperclip,
    'mdi:file-delimited-outline': FileCsv,
    'mdi:file-pdf-box': FilePdf,
    'lucide:file-text': FileText,
    'mdi:text-box-outline': FileText,
    'mdi:format-list-bulleted': ListBullets,
    'mdi:flag-outline': Flag,
    'mdi:inbox-arrow-down-outline': Tray,
    'mdi:account': User,
    'mdi:account-outline': User,
    'mdi:home': House,
    'mdi:home-map-marker': House,
    'mdi:phone': Phone,
    'mdi:email': Envelope,
    'mdi:id-card': IdentificationCard,
    'mdi:card-account-details': IdentificationCard,
    'mdi:clock': Clock,
    'mdi:file-document': FileText,
    'mdi:note-text': ChatText,
    'mdi:priority-high': Flag,
    'mdi:source': Tray,
    'mdi:office-building': Buildings,
    'mdi:alert-circle': Info,
    'mdi:information-outline': Info,
    'mdi:star': Star,
    'mdi:source-branch': GitBranch,
    'mdi:comment': ChatText,
    'mdi:comment-text-outline': ChatText,
    'mdi:account-check': UserCheck,
    'mdi:account-check-outline': UserCheck,
    'mdi:clock-outline': Clock,
    'mdi:cancel': Prohibit,
    'mdi:sort': ArrowsDownUp,
    'mdi:arrow-up': ArrowUp,
    'mdi:arrow-down': ArrowDown,
    'ep:d-arrow-left': CaretDoubleLeft,
    'ep:d-arrow-right': CaretDoubleRight,
    'mdi:chart-box-outline': ChartBar,
    'mdi:lock-open-variant-outline': LockOpen,
    'mdi:account-clock-outline': Clock,
    'mdi:alert-octagon-outline': WarningOctagon,
    'mdi:check-decagram-outline': SealCheck,
    'mdi:lock-reset': ArrowsClockwise,
    'mdi:check-circle-outline': CheckCircle,
    'mdi:check-circle': CheckCircle,
};

const ComplaintIcon = ({ icon, width, height, weight = 'regular', ...props }) => {
    const Glyph = icons[icon];
    return Glyph
        ? <Glyph size={width || height || '1em'} weight={weight} data-complaint-icon={icon} {...props} />
        : <FallbackIcon icon={icon} width={width} height={height} {...props} />;
};

export default ComplaintIcon;
